import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleTreeView, TreeItem2 } from "@mui/x-tree-view";
import { AdjacentType, NetworkApplicationServerClassName, SYSTEM } from "@iotv/datamodel-core";
import { edgeTypeMatrix } from "@iotv/datamodel-core";
import { ObjectTree } from "../../../v2/components/generic/ObjectTree";
export const LNSTree = ({ applicationData, contextCustomer, roleArbitrationInstance, transactionFunctions, user }) => {
    return _jsx(SimpleTreeView, { title: 'lns', children: _jsx(TreeItem2, { nodeId: 'lnsRoot',
            label: 'lns',
            itemId: 'lnsRoot', children: _jsx(ObjectTree, { contextObjects: [SYSTEM],
                hideTopStep: true,
                uniqueTreeId: 'lnsTree',
                nodeEdgeMapper: applicationData,
                queryPaths: [
                    {
                        stepQuery: {
                            objectTypeId: NetworkApplicationServerClassName,
                            adjacencyType: AdjacentType.CHILD,
                            edgeTypeId: edgeTypeMatrix.System.LoRaWANApplicationServer.system_has_LoRaWANApplicationServer.edgeTypeId
                        },
                        nextSteps: [
                        // {
                        //     stepQuery: {
                        //         objectTypeId: 'Device',
                        //         adjacencyType: AdjacentType.CHILD,
                        //         edgeTypeId: edgeTypeMatrix.AWSAccount.Device.awsAccount_has_device.edgeTypeId
                        //     }
                        // }
                        ]
                    }
                ] }) }, 'lnsRoot') });
};
